var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.DropdownWindow = new Class({
    Implements: [Options, Events],
    element: null,
    options: {
        selector_id: "dropdown_container",
        hidden_class: "hidden",
        active_class: "active",
        reference_container_id: "panel_container",
        prcnt_hght_ref_container: 0.9,
        product_class_selector: "product_content"
    },
    bound_methods: {},
    initialize: function (ops) {
        this.setOptions(ops);
        this.bound_methods.on_click = this.on_click.bind(this);
        this.element = document.id(this.options.selector_id);
        var self = this.element.retrieve('menu_obj');
        if (self) {
            return self;
        } else {
            this.element.store('menu_obj', this);
        }
    },
    position: function (el) {
        var pos = el.getCoordinates();
        if (!OCS.device.mobile) {
            this.element.setPosition({y: pos.top + pos.height - 1, x: pos.left});
        }
        this.element.setStyle('max-height', Math.floor(document.id(this.options.reference_container_id).getSize().y * this.options.prcnt_hght_ref_container));

        return this;
    },
    content: function (element) {
        this.element.removeEvent('click', this.bound_methods.on_click);
        this.element.empty();
        element.inject(this.element);
        this.element.addEvent('click', this.bound_methods.on_click);
        return this;
    },
    hide: function () {
        this.element.removeClass(this.options.active_class);
        this.element.addClass(this.options.hidden_class);
        this.element.removeEvent('click', this.bound_methods.on_click);
        this.element.empty();
        this.removeEvents();
    },
    show: function () {
        this.element.addClass(this.options.active_class);
        this.element.removeClass(this.options.hidden_class);
        OCS.WxBriefing.Functions.get_event_manager().publish("vertical_menu_shown", this.element);
        OCS.WxBriefing.Functions.get_product_drag().init_draggable();
    },
    on_click: function (event) {
        var target = event.target;
        event.stopped = false;
        if (target.hasClass('reset_menu')) {
            OCS.WxBriefing.Functions.get_ui_menu().reset_menu();
        }
        // Click event for any special behaviors
        this.fireEvent('click', [event, target]);
        if (event.stopped) {
            return;
        }
        if (target.get('data-product_type') === OCS.Constants.EXTERNAL_URL) {
            return;
        }
        event.stop();
        if (target.hasClass('panel_config')) {
            // This is a panel config
            OCS.WxBriefing.Functions.get_ui_menu().reset_menu();
            OCS.WxBriefing.Functions.get_url_manager().update_url_state(target.get('data-href'), 0);
            return;
        }
        var product_content;
        if (target.hasClass('product_content')) {
            product_content = target;
        } else {
            product_content = target.getParent('.'+this.options.product_class_selector);
        }
        if(product_content) {
            // This is a product
            var entry_id = product_content.get('data-entry_id');
            var cat_id = product_content.get('data-cat_id');
            if (typeof entry_id !== 'undefined' && entry_id !== null) {
                if (OCS.WxBriefing.Functions.get_product_manager().get_product_type(entry_id) !== OCS.Constants.EXTERNAL_URL) {
                    OCS.WxBriefing.Functions.get_preview_window().show(product_content);
                }
            } else if (typeof cat_id !== 'undefined' && cat_id !== null) {
                this.show_category_preview(product_content);
            }
            this.fireEvent('click_product', [event, product_content]);
            return;
        }

    },
    on_click_product: function (event) {
        var target = event.event.currentTarget;
        event.stop();
        var entry_id = target.get('data-entry_id');
        var cat_id = target.get('data-cat_id');
        if (typeof entry_id !== 'undefined' && entry_id !== null) {
            if (OCS.WxBriefing.Functions.get_product_manager().get_product_type(entry_id) !== OCS.Constants.EXTERNAL_URL) {
                OCS.WxBriefing.Functions.get_preview_window().show(target);
            }
        } else if (typeof cat_id !== 'undefined' && cat_id !== null) {
            this.show_category_preview(target);
        }
        this.fireEvent('click_product', [event, target]);
    },
    destroy: function () {
        if (this.element) {
            this.element.store('menu_obj', null);
            this.element.removeEvent('click', this.bound_methods.on_click);
            this.element = null;
        }
        this.removeEvents();
    }

});